import type React from "react";
import { Text } from "@simplybusiness/mobius";

interface QuoteReferenceProps {
  referenceNumbers: string[];
}

export const QuoteReference = ({ referenceNumbers }: QuoteReferenceProps) => {
  if (!referenceNumbers || referenceNumbers.length === 0) return null;

  function getJoinedReferences(referenceNumbers: string[]): React.ReactNode {
    if (!referenceNumbers.length) return null;

    const items = referenceNumbers.map(ref => (
      <strong key={ref} className="mobius-quote-help__reference-number">
        {ref}
      </strong>
    ));

    if (items.length === 1) {
      return items[0];
    }
    if (items.length === 2) {
      return [items[0], " and ", items[1]];
    }

    return [
      ...items.slice(0, -1).map(item => [item, ", "]),
      "and ",
      items[items.length - 1],
    ].flat();
  }
  return (
    <Text variant="body">
      Quote reference ID: {getJoinedReferences(referenceNumbers)}
    </Text>
  );
};
